var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFtCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 11.5L.5 4.9l1.4-1.4 5.1 5L14.3.3l1.4 1.4z"
  })));
}
export default SvgFtCheckmark;